<template>
  <div class="container centeredContainer">
    <div class="row">
      <div class="col-md-4 offset-md-4">
        <div class="center-container">
          <h1 class="title is-1">{{ $t("AppMenu.new-league") }}</h1>
          <p v-if="error" class="error">
            {{ error }}
          </p>
          <div style="width: 400px; max-width: 90%; margin: 0 auto">
            <form @submit.prevent="createLeague" autocomplete="off">
              <b-field :label="$t('what-should-we-call-your-league')">
                <b-input
                  autofocus="true"
                  v-model.trim="name"
                  style="border: 1px solid grey; border-radius: 5px"
                  :placeholder="$t('Wizard.wizardPlaceholder.leaguename')"
                >
                </b-input>
              </b-field>
              <b-field :label="$t('what-should-we-call-your-season')">
                <b-input
                  v-model.trim="seasonName"
                  style="border: 1px solid grey; border-radius: 5px"
                  :placeholder="$t('Wizard.wizardPlaceholder.seasonname')"
                >
                </b-input>
              </b-field>
              <button type="submit" class="button">{{ $t("create-league") }}</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Errors from "@/components/Errors";
import api from "@/api";

export default {
  components: { Errors },
  data() {
    return {
      name: "",
      seasonName: "",
      error: "",
    };
  },
  methods: {
    createLeague() {
      api
        .createLeague(this.name, this.seasonName)
        .then(response => {
          this.makeToast("success", this.$t("created-league"));
          this.setCurrentLeagueSeasonId(response.data.league.id, response.data.season.id);
          this.goRouter(this.getURLParam("return") || "/");
        })
        .catch(error => {
          this.errors = error.response.data.errors;
        });
    },
  },
  mounted() {
    window.analytics.page();
  },
};
</script>

<style scoped lang="scss">
form {
  margin-top: 1rem;
}
</style>
